import ITINError from './ITINError';

export default ITINError;
